import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import Banner from 'components/common/Banner/Banner'
import Link from 'components/common/Link/Link'

const BOTNoAccountMessage = ({ message, createAccountLink, ...props }) =>
  <Wrapper { ...props }>
    <Banner warning>
      <Message data-at-myaccount-noaccountmessage>{ message }</Message>
      <Link data-at-myaccount-createaccountlink bolder to={ createAccountLink }>Create an Account</Link>
    </Banner>
  </Wrapper>

BOTNoAccountMessage.propTypes = {
  '@type': PropTypes.string,
  createAccountLink: PropTypes.string,
  message: PropTypes.string,
  name: PropTypes.string
}

BOTNoAccountMessage.type = 'BOTNoAccountMessage'

export default BOTNoAccountMessage

const Message = styled.span`
  font-weight: 600;
  line-height: 19px;
  ${Mixin.responsive('margin-right', '10px', '5px')}
`

const Wrapper = styled.div`
  ${Media.mobile`
    padding: 0 16px;
  `}
`
